module.exports = __webpack_public_path__ + "img/slide3-content.4fbe35de.png";